import { Overline, Reveal } from "./Shared";

const STEPS = [
  {
    num: "01",
    title: "Tell us what happened",
    body: "Complete the short confidential form. It takes about two minutes and requires only basic contact details and your case type.",
  },
  {
    num: "02",
    title: "Individual review",
    body: "Your inquiry is reviewed against active matters in your state. Nothing is auto-decided, and no outcome is promised.",
  },
  {
    num: "03",
    title: "Free consultation",
    body: "If your inquiry matches an active review, an independent legal professional may contact you to discuss options — free and with no obligation.",
  },
];

const Process = () => (
  <section
    id="process"
    data-testid="process-section"
    className="border-b border-[#E7E2DA] py-20 sm:py-28 scroll-mt-20"
  >
    <div className="mx-auto max-w-7xl px-5 sm:px-10 lg:px-16">
      <Reveal className="max-w-2xl">
        <Overline>Chapter 04 — The Process</Overline>
        <h2 className="mt-4 font-serif font-semibold text-3xl sm:text-4xl tracking-tight text-[#1A1715] leading-tight">
          Simple, transparent, and on your timeline.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 border-t border-b border-[#E7E2DA] divide-y md:divide-y-0 md:divide-x divide-[#E7E2DA]">
        {STEPS.map((s, i) => (
          <Reveal key={s.num} delay={i * 0.12} className="p-8 sm:p-10">
            <span className="font-serif italic text-4xl text-[#B45309]/50">
              {s.num}
            </span>
            <h3 className="mt-4 font-serif font-semibold text-2xl text-[#1A1715]">
              {s.title}
            </h3>
            <p className="mt-3 font-sans text-sm text-[#78716C] leading-relaxed">
              {s.body}
            </p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
